import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { UserGroupContextZod, UsersTableDefinitionZod } from '../tables';

type Arguments = {
    position: number;
};

export const schemaUserResolver_ListActivated = z.array(
    UsersTableDefinitionZod.pick({
        assignable: true,
        avatar: true,
        certFileName: true,
        delegateId: true,
        email: true,
        europacePlatforms: true,
        firstName: true,
        gender: true,
        id: true,
        lastName: true,
        organization: true,
        phone: true,
        registered: true,
        role: true,
        signatureId: true,
        smtp: true,
        teamId: true,
        title: true,
    })
        .merge(UserGroupContextZod)
        .merge(z.object({ ledTeamId: z.string().optional(), teamLeaderId: z.string().optional() })),
);

export type SchemaUserResolver_ListActivated = z.infer<typeof schemaUserResolver_ListActivated>;

export type UserResolver_ListActivated = Resolver<Arguments, SchemaUserResolver_ListActivated>;
